export const groupByColumn = (items)=>{
    const columnIndexes = [
        ...new Set(items.map((item)=>item.column))
    ].sort((a, b)=>a - b);
    return columnIndexes.map((column)=>items.filter((item)=>item.column === column).map((item)=>item.node));
};
